const DefaultIcons = {
  iconParentClose:
  `
    <span style="width: 14px; display: inline-block; content: '';">
      <svg
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M3,2 L13,2 C13.5522847,2 14,2.44771525 14,3 L14,13 C14,13.5522847 13.5522847,14 13,14 L3,14 C2.44771525,14 2,13.5522847 2,
            13 L2,3 C2,2.44771525 2.44771525,2 3,2 Z M7,7 L4,7 L4,9 L7,9 L7,12 L9,12 L9,9 L12,9 L12,7 L9,7 L9,4 L7,4 L7,7 Z"
            fill="#5E6678"
            fill-rule="nonzero"
          ></path>
        </g>
      </svg>
    </span>
  `,
  iconParentOpen:
  `
    <span style="width: 14px; display: inline-block; content: '';">
      <svg
        width="16px"
        height="16px"
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M3,2 L13,2 C13.5522847,2 14,2.44771525 14,3 L14,13 C14,13.5522847 13.5522847,14 13,14 L3,14 C2.44771525,14 2,13.5522847 2,
            13 L2,3 C2,2.44771525 2.44771525,2 3,2 Z M12,7 L4,7 L4,9 L12,9 L12,7 Z"
            fill="#5E6678"
            fill-rule="nonzero"
          ></path>
        </g>
      </svg>
    </span>
  `,
  iconLeaf: `
    <span style="width: 14px; display: inline-block; content: '';"></span>
  `
};

export default {
  ...DefaultIcons
};

export {
  DefaultIcons
};
